import request from "helpers/api_helper";
import { toast } from "react-toastify";

// Get all holidays
export const getHolidays = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `holidays${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch holidays");
    return error;
  }
};

// Get single holiday
export const getHoliday = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `holidays/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch holiday");
    return error;
  }
};

// Create new holiday
export const createHoliday = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "holidays",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Holiday created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create holiday");
    return error;
  }
};

// Update holiday
export const updateHoliday = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `holidays/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Holiday updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update holiday");
    return error;
  }
};

// Delete holiday
export const deleteHoliday = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `holidays/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Holiday deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete holiday");
    return error;
  }
};

// Update weekday settings
export const updateWeekdaySettings = async (data: Record<string, boolean>) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "holidays/weekdays",
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Weekday settings updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update weekday settings");
    return error;
  }
};

// Get weekday settings
export const getWeekdaySettings = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "holidays/weekdays",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch weekday settings");
    return error;
  }
};